export const AVAILIBILITY = "availability";
export const SIZES = "sizes";
export const COLORS = "colors";
export const PRICE = "price";
export const VENDORS = "vendors";
export const SORT_BY = "sortBy";

export const IN_STOCK = "InStock";
export const OUT_OF_STOCK = "OutOfStock";
